// @flow

import * as R from "ramda";
import { createSelector } from "reselect";

import { getAllChartIds, getCurrentDashboardCharts } from "src/reducers";

export const getFilteredDashboardCharts = createSelector(
  [getAllChartIds, getCurrentDashboardCharts],
  (allCharts, currentDashboardCharts) => {
    const allChartIds = allCharts.map(chart => chart.id);
    const currentDashboardChartIds = currentDashboardCharts.map(
      chart => `${chart.id}`
    );

    const filteredChartList = allCharts.filter(
      chart => !currentDashboardChartIds.includes(chart.id)
    );

    return filteredChartList;
  }
);
